/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Sales_Consultant_RequiredInputs */

const en_clients_validation_sales_consultant_required = /** @type {(inputs: Clients_Validation_Sales_Consultant_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales consultant is required.`)
};

const pt_br2_clients_validation_sales_consultant_required = /** @type {(inputs: Clients_Validation_Sales_Consultant_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultor comercial é obrigatório.`)
};

/**
* | output |
* | --- |
* | "Sales consultant is required." |
*
* @param {Clients_Validation_Sales_Consultant_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_sales_consultant_required = /** @type {((inputs?: Clients_Validation_Sales_Consultant_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Sales_Consultant_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_sales_consultant_required(inputs)
	return pt_br2_clients_validation_sales_consultant_required(inputs)
});